import React from "react";
import { FLOW_GROUPS, UAT_LANDING_BASE } from "./constants";
import "./style.scss";

const DeeplinkTest = () => {
  const [copied, setCopied] = React.useState(null);

  const handleCopy = (url, key) => {
    const done = () => {
      setCopied(key);
      setTimeout(() => setCopied(null), 1500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(() => {});
    } else {
      done();
    }
  };

  return (
    <div className="deeplinkTest">
      <div className="deeplinkTest-head">
        <h2 className="deeplinkTest-title">ทดสอบ Deeplink</h2>
        <span className="deeplinkTest-env">UAT</span>
      </div>
      <p className="deeplinkTest-desc">
        เปิดหน้านี้บนอุปกรณ์ที่ติดตั้งแอป Principal TH (UAT) แล้วกด{" "}
        <b>เปิดลิงก์</b> ของแต่ละ flow เพื่อทดสอบว่ากดแล้วเข้า flow ตามที่ต้องการ
        จริงหรือไม่ ทุกลิงก์ชี้ไปที่ UAT landing (
        <code>{UAT_LANDING_BASE}</code>) ซึ่งจะเปิดแอปผ่าน scheme{" "}
        <code>cpamapp://</code> หรือเด้งไปสโตร์/QR หากยังไม่ได้ติดตั้งแอป
      </p>

      {FLOW_GROUPS.map((group) => (
        <div className="deeplinkTest-group" key={group.key}>
          <h3 className={`deeplinkTest-groupTitle is-${group.key}`}>
            {group.title}
          </h3>
          <div className="deeplinkTest-cards">
            {group.flows.map((flow) => (
              <div className="deeplinkTest-card" key={flow.key}>
                <div className="deeplinkTest-cardHead">
                  <span className="deeplinkTest-cardName">{flow.nameTh}</span>
                  <span className={`deeplinkTest-badge is-${group.key}`}>
                    {group.key === "public" ? "Public" : "Private"}
                  </span>
                </div>
                <span className="deeplinkTest-cardEn">{flow.nameEn}</span>
                <p className="deeplinkTest-expected">{flow.expected}</p>

                <div className="deeplinkTest-linkRow">
                  <span className="deeplinkTest-linkLabel">ลิงก์ทดสอบ (UAT)</span>
                  <a
                    className="deeplinkTest-url"
                    href={flow.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {flow.url}
                  </a>
                </div>
                <div className="deeplinkTest-scheme">
                  App scheme: <code>{flow.scheme}</code>
                </div>

                <div className="deeplinkTest-actions">
                  <a
                    className="deeplinkTest-btn is-primary"
                    href={flow.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    เปิดลิงก์
                  </a>
                  <button
                    type="button"
                    className="deeplinkTest-btn is-ghost"
                    onClick={() => handleCopy(flow.url, flow.key)}
                  >
                    {copied === flow.key ? "คัดลอกแล้ว ✓" : "คัดลอกลิงก์"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DeeplinkTest;
